import { render, staticRenderFns } from "./DeleteLocalizationConfirmation.vue?vue&type=template&id=22e86fd1&"
import script from "./DeleteLocalizationConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteLocalizationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports